module.exports = "<div class=ui-select-footer ng-transclude></div> ";